export const handleDownloadBtnClick = () => {
  window.location.href =
    "https://play.google.com/store/apps/details?id=az.yonca";
};
